import StartNode from './StartNode'
import LocationNode from './LocationNode'
import DecisionNode from './DecisionNode'
import ExitNode from './ExitNode'
import LoopNode from './LoopNode'
import DelayNode from './DelayNode'
import TimerControlNode from './TimerControlNode'
import ChallengeNode from './ChallengeNode'
import RewardNode from './RewardNode'
import RouteNode from './RouteNode'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const nodeTypes: Record<string, any> = {
  startNode: StartNode,
  locationNode: LocationNode,
  decisionNode: DecisionNode,
  exitNode: ExitNode,
  loopNode: LoopNode,
  delayNode: DelayNode,
  timerControlNode: TimerControlNode,
  // Challenge node types - all use the same ChallengeNode component
  questionAnswerNode: ChallengeNode,
  qrCodeNode: ChallengeNode,
  numericInputNode: ChallengeNode,
  moderatorApprovalNode: ChallengeNode,
  codexInputNode: ChallengeNode,
  // Reward node types - all use the same RewardNode component
  poiLocationNode: RewardNode,
  textClueNode: RewardNode,
  audioPlayerNode: RewardNode,
  videoPlayerNode: RewardNode,
  imageDisplayNode: RewardNode,
  unlockAdventureNode: RewardNode,
  timeModifierNode: RewardNode,
  formattedMessageNode: RewardNode,
  groupMembershipNode: RewardNode,
  giftRewardNode: RewardNode,
  // Route node
  routeNode: RouteNode,
}

export { StartNode, LocationNode, DecisionNode, ExitNode, LoopNode, DelayNode, TimerControlNode, ChallengeNode, RewardNode, RouteNode }
